<template>
    <div class="login_box">
        <div class="logo_box">
            <router-link :to="`/`">
                <img src="../../public/img/logo.png"
                     alt="logo">
            </router-link>
        </div>
        <div class="login_bg_box">
            <div class="login_bg_box_positon">
                <div class="login_bg">
                    <img src="../../public/img/login_bg.png"
                         alt="">
                </div>
                <div class="login">
                    <div class="tit">
                        會員登錄
                    </div>
                    <div>
                        <el-form ref="formValidate"
                                 :model="loginInfo"
                                 :rules="ruleValidate">
                            <el-form-item prop="user_id">
                                <el-input v-model="loginInfo.user_id"
                                          type="text"
                                          placeholder="請輸入賬號"
                                          prefix-icon="iconfont el-icon-user"
                                          clearable />
                            </el-form-item>
                            <el-form-item prop="user_pwd">
                                <el-input v-model="loginInfo.user_pwd"
                                          type="password"
                                          clearable
                                          placeholder="請輸入密碼"
                                          prefix-icon="iconfont el-icon-lock" />
                            </el-form-item>
                            <el-form-item prop="code">
                                <el-input v-model="loginInfo.code"
                                          type="text"
                                          clearable
                                          placeholder="請輸入驗證碼"
                                          prefix-icon="iconfont icon-al-yanzhengma2"
                                          style="width: 200px" />
                                <img class="captcha_img"
                                     :src="captcha_img"
                                     @click="captcha_image">
                            </el-form-item>
                            <div class="errorMsg"
                                 :style="{
              visibility: errorMsg == '' ? 'hidden' : 'visible',
            }">
                                {{ errorMsg }}
                            </div>
                            <el-form-item>
                                <el-button class="common_btn"
                                           :loading="loginInfo.loading"
                                           style="width:100%"
                                           @click="CheckLogin()">
                                    {{ loginInfo.loading ? '正在登錄' : '登錄' }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <MainFooter />
    </div>
</template>

<script>
import MainFooter from "@/components/Footer";
import { ServerPath } from "@/config/serverPath";
import { loginOut } from "@/api/userAPI";
export default {
    components: { MainFooter },
    data() {
        return {
            loginInfo: {
                user_id: "", // 会员ID
                user_pwd: "", // 密码
                code: "", // 验证码
                loading: false, // 是否登录中
            },
            ruleValidate: {
                user_id: [
                    {
                        required: true,
                        message: "賬號不能為空",
                        trigger: "blur",
                    },
                ],
                user_pwd: [
                    {
                        required: true,
                        message: "密碼不能為空",
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "驗證碼不能為空",
                        trigger: "blur",
                    },
                ],
            },
            // 服务器返回错误信息
            errorMsg: "",
            // 验证码图片地址
            captcha_img: `${ServerPath}/captcha/captcha.html`,
        };
    },
    created() {
        localStorage.removeItem("token");
    },
    methods: {
        CheckLogin() {
            this.loginInfo.loading = true;
            // this.$refs['loginInfo']   表单对象,val是表单校验成功或失败的返回值
            this.$refs["formValidate"].validate(async (val) => {
                if (val) {
                    // 修改仓库数据
                    var resp = await this.$store.dispatch(
                        "loginUser/login",
                        this.loginInfo
                    );
                    if (resp.result) {
                        this.$message({
                            type: "success",
                            message: "登錄成功!",
                            center: true,
                        });
                        this.$router.push({
                            name: "Center",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: "登錄失敗",
                            center: true,
                        });
                        this.errorMsg = resp.data.msg;
                        this.captcha_image();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: "輸入錯誤",
                        center: true,
                    });
                }
                this.loginInfo.loading = false;
            });
        },
        captcha_image() {
            this.captcha_img =
                `${ServerPath}/captcha/captcha.html?r=` + Math.random();
        },
    },
};
</script>

<style scoped lang="scss">
.login_box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    .logo_box {
        width: 1300px;
        margin: 0 auto;
    }
    .login_bg_box {
        height: auto;
        overflow: hidden;
        width: 1300px;
        margin: 0 auto;
        position: relative;
        .login_bg_box_positon {
            position: relative;
            top: 50%;
            overflow: hidden;
            padding: 80px 0;
            .login_bg {
                float: left;
                height: auto;
                overflow: hidden;
                img {
                    height: 500px;
                }
                margin-left: 50px;
            }
            .login {
                width: 400px;
                height: 380px;
                background-color: #fff;
                margin: 30px 0;
                float: right;
                border-radius: 15px;
                box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
                padding: 30px;
                margin-right: 30px;
                .tit {
                    text-align: center;
                    font-size: 30px;
                    margin: 10px 0 40px 0;
                    img {
                        width: 50%;
                        display: block;
                        margin: 0 auto;
                    }
                }
                .errorMsg {
                    font-size: 14px;
                    color: #ed4014;
                    text-align: center;
                    height: 20px;
                    line-height: 10px;
                }
                .captcha_img {
                    display: block;
                    float: right;
                    margin-right: 30px;
                }
            }
        }
    }
}
</style>
